{
	"name": "infoday",
	"version": "4.1.0",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"prebuild": "node scripts/write-meta.js",
		"development": "ng build --configuration development",
		"build": "npm run prettier && ng cache clean && npm run prebuild && ng build --configuration production",
		"watch": "ng build --watch --configuration development",
		"test": "ng test",
		"lint": "ng lint",
		"e2e": "ng e2e",
		"release": "release-it",
		"prettier": "npx prettier --write .",
		"ai:check": "node ./scripts/ai-check.mjs"
	},
	"private": true,
	"dependencies": {
		"@angular/animations": "^22.0.0",
		"@angular/cdk": "^22.0.0",
		"@angular/common": "^22.0.0",
		"@angular/compiler": "^22.0.0",
		"@angular/core": "^22.0.0",
		"@angular/forms": "^22.0.0",
		"@angular/material": "^22.0.0",
		"@angular/platform-browser": "^22.0.0",
		"@angular/platform-browser-dynamic": "^22.0.0",
		"@angular/router": "^22.0.0",
		"@auth0/angular-jwt": "^5.0.1",
		"@builder.io/partytown": "^0.6.4",
		"@datorama/akita": "^7.1.1",
		"@datorama/akita-ng-entity-service": "^7.0.0",
		"@espressotutorialsgmbh/espresso-tailwind-config": "^2.2.0",
		"@fortawesome/angular-fontawesome": "^4.0.0",
		"@fortawesome/fontawesome-svg-core": "^7.1.0",
		"@fortawesome/free-brands-svg-icons": "^7.1.0",
		"@fortawesome/free-solid-svg-icons": "^7.1.0",
		"@fortawesome/pro-light-svg-icons": "^7.2.0",
		"@fortawesome/pro-regular-svg-icons": "^7.1.0",
		"@fortawesome/pro-solid-svg-icons": "^7.2.0",
		"@fortawesome/sharp-solid-svg-icons": "^7.1.0",
		"@jsverse/transloco": "^7.6.1",
		"@jsverse/transloco-locale": "^7.0.1",
		"@nicky-lenaers/ngx-scroll-to": "^14.0.0",
		"@sentry/angular": "^9.21.0",
		"@sentry/angular-ivy": "^7.120.3",
		"@sentry/tracing": "^7.120.3",
		"@videogular/ngx-videogular": "^10.0.1",
		"@zoom/meetingsdk": "^6.2.0",
		"date-fns": "^2.29.1",
		"date-fns-timezone": "^0.1.4",
		"filesize": "^9.0.11",
		"hls.js": "^1.5.10",
		"idb": "^8.0.3",
		"marked": "^4.0.18",
		"ngx-cookie-service": "^19.1.2",
		"ngx-filesize": "^3.0.5",
		"ngx-skeleton-loader": "^11.1.0",
		"prettier-plugin-tailwindcss": "^0.6.11",
		"pusher-js": "^8.4.0-rc2",
		"rxjs": "^7.8.2",
		"slugify": "^1.6.6",
		"swiper": "^8.4.7",
		"tailwindcss-animated": "^2.0.0",
		"timezone-support": "^2.0.2",
		"tslib": "^2.0.0",
		"zone.js": "~0.15.0"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "^22.0.0",
		"@angular-devkit/core": "^22.0.0",
		"@angular/cli": "^22.0.0",
		"@angular/compiler-cli": "^22.0.0",
		"@datorama/akita-ng-router-store": "^6.0.0",
		"@datorama/akita-ngdevtools": "^6.0.0",
		"@espressotutorialsgmbh/et-angular-ai-bootstrap": "^0.0.5",
		"@release-it/conventional-changelog": "^10.0.1",
		"@types/jasmine": "~3.6.0",
		"@types/jasminewd2": "~2.0.3",
		"@types/node": "^12.11.1",
		"autoprefixer": "^10.4.7",
		"codelyzer": "^6.0.0",
		"istanbul-lib-instrument": "^6.0.3",
		"jasmine-core": "~3.6.0",
		"jasmine-spec-reporter": "~5.0.0",
		"karma": "~6.3.20",
		"karma-chrome-launcher": "~3.1.0",
		"karma-coverage-istanbul-reporter": "~3.0.2",
		"karma-jasmine": "~4.0.0",
		"karma-jasmine-html-reporter": "^1.5.0",
		"postcss": "^8.4.29",
		"postcss-import": "13.0.0",
		"postcss-loader": "4.0.4",
		"postcss-scss": "3.0.4",
		"prettier": "^3.3.1",
		"protractor": "~7.0.0",
		"release-it": "^19.0.2",
		"tailwindcss": "^3.4.17",
		"ts-node": "~8.3.0",
		"typescript": "~6.0.3"
	},
	"release-it": {
		"plugins": {
			"@release-it/conventional-changelog": {
				"preset": "angular",
				"infile": "CHANGELOG.md"
			}
		}
	}
}
